// extracted by mini-css-extract-plugin
module.exports = {"heading":"hero-heading_heading__grSW9"};